import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import { mergeRowResponseFromTop } from 'owa-mail-list-response-processor';
import { action } from 'satcheljs/lib/legacy';
/**
 * Called after reload table is successful
 * @param tableView to be reloaded
 * @param reloadedRows the rows that returned in the service response for reload
 * @param totalRowsInView the total rows in view that returned in the service response for reload
 */
export var onReloadTableSucceeded = action('onReloadTableSucceeded')(function onReloadTableSucceeded(tableView, reloadedRows, totalRowsInView) {
    // Merge reloaded results from the top
    mergeRowResponseFromTop(reloadedRows, tableView, totalRowsInView, true /* removeRemainingRowsAfterMerge */, false /* shouldLogIsDatauptodate */);
    // Set the currentLoadedIndex to the min of tableRows length regardless of what it is as
    // this number is already optimized when we made the reload request
    tableView.currentLoadedIndex = tableView.rowKeys.length;
});
/**
 * Called after reload table failed
 * @param responseCode the response code contained inside the reload response
 */
export var onReloadTableFailed = action('onReloadTableFailed')(function onReloadTableFailed(responseCode) {
    logUsage(datapoints.reloadTableServerError.datapoint.name, datapoints.reloadTableServerError.datapoint.customData(responseCode));
});
//# sourceMappingURL=onReloadTableCompleted.js.map